export default "__VITE_ASSET__CyLYWCi2__"